import { render, staticRenderFns } from "./AssignmentIcon.vue?vue&type=template&id=1e0ae9b8&scoped=true&"
import script from "./AssignmentIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AssignmentIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0ae9b8",
  null
  
)

export default component.exports